<template>
  <div>
    <div class="row mb-4">
      <div class="col-lg-4 mb-4">
        <stat-card label="Tổng bài viết" :value="dashboard.postCount" hint="Bao gồm toàn bộ bài chưa xóa" />
      </div>
      <div class="col-lg-4 mb-4">
        <stat-card label="Tổng liên hệ" :value="dashboard.totalContacts" hint="Tất cả yêu cầu tư vấn đã gửi" />
      </div>
      <div class="col-lg-4 mb-4">
        <stat-card label="Liên hệ mới" :value="dashboard.newContacts" hint="Cần ưu tiên phản hồi" />
      </div>
    </div>

    <div class="admin-card bg-white p-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h2 class="h5 font-weight-bold text-primary mb-0">Bài viết mới nhất</h2>
      </div>
      <b-table :items="dashboard.latestPosts" :fields="fields" responsive striped>
        <template #cell(createdAt)="row">
          {{ formatDate(row.item.createdAt) }}
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { fetchDashboard } from "../../api/admin";
import StatCard from "../../components/StatCard.vue";
import { isUnauthorizedError } from "../../utils/apiErrors";
import { formatDate } from "../../utils/formatters";

export default {
  name: "AdminDashboardView",
  components: {
    StatCard
  },
  data: function data() {
    return {
      fields: [
        { key: "title", label: "Tiêu đề" },
        { key: "displayOrder", label: "Thứ tự" },
        { key: "createdAt", label: "Ngày tạo" }
      ],
      dashboard: {
        postCount: 0,
        totalContacts: 0,
        newContacts: 0,
        latestPosts: []
      }
    };
  },
  created: function created() {
    this.loadDashboard();
  },
  methods: {
    formatDate,
    async loadDashboard() {
      try {
        const response = await fetchDashboard();
        this.dashboard = response.data;
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    }
  }
};
</script>

